(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ambassador-application-modal"] && !Shopify.designMode) return;
  try {
    
  function initAmbassadorApplication() {
    const dialog = document.getElementById('vim-ambassador-application');
    if (!dialog || dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';
    let trigger = null;
    const links = document.querySelectorAll('a[href="#vim-ambassador-application"]');
    links.forEach((link) => {
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-controls', dialog.id);
      link.addEventListener('click', (event) => {
        event.preventDefault();
        trigger = link;
        if (!dialog.open) dialog.showModal();
      });
    });
    dialog.querySelector('[data-ambassador-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (trigger?.isConnected) trigger.focus();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAmbassadorApplication);
  else initAmbassadorApplication();
  document.addEventListener('shopify:section:load', initAmbassadorApplication);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  class ShareLinks extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.status = this.querySelector('[data-status]');
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      if (this.timer) clearTimeout(this.timer);
    }

    onClick(event) {
      const button = event.target.closest ? event.target.closest('[data-copy]') : null;
      if (!button) return;
      event.preventDefault();
      this.copy(button);
    }

    async copy(button) {
      const url = this.dataset.url || window.location.href;

      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(url);
        } else if (navigator.share) {
          await navigator.share({ url: url });
          return;
        } else {
          throw new Error('unsupported');
        }
        this.announce(button.dataset.copied);
      } catch (error) {
        if (error && error.name === 'AbortError') return;
        this.announce(button.dataset.failed);
      }
    }

    announce(text) {
      if (!this.status) return;
      this.status.textContent = text || '';
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.status.textContent = '';
      }, 2500);
    }
  }

  if (!customElements.get('share-links')) {
    customElements.define('share-links', ShareLinks);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  class BlogListing extends HTMLElement {
    constructor() {
      super();
      this.loading = false;
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
    }

    connectedCallback() {
      this.grid = this.querySelector('[data-articles]');
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      if (this.controller) this.controller.abort();
    }

    onKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const button = event.target.closest ? event.target.closest('a[data-load-more][role="button"]') : null;
      if (!button) return;
      event.preventDefault();
      button.click();
    }

    onClick(event) {
      const button = event.target.closest ? event.target.closest('[data-load-more]') : null;
      if (!button || !this.grid) return;
      event.preventDefault();
      if (this.loading) return;

      if (this.revealHidden(button)) return;
      if (button.href) this.load(button);
    }

    hiddenCards() {
      return Array.from(this.grid.querySelectorAll('.blog__item--overflow:not(.is-revealed-item)'));
    }

    revealHidden(button) {
      if (!window.matchMedia('(max-width: 749px)').matches) return false;

      const hidden = this.hiddenCards();
      if (hidden.length === 0) return false;

      hidden.forEach((card) => card.classList.add('is-revealed-item'));
      this.grid.dispatchEvent(new CustomEvent('reveal:scan', { bubbles: true }));
      if (typeof hidden[0].focus === 'function') hidden[0].focus();

      if (!button.href) {
        const wrapper = button.closest('.blog__more') || button;
        wrapper.remove();
      }
      return true;
    }

    async load(button) {
      this.loading = true;
      button.setAttribute('aria-busy', 'true');
      this.controller = new AbortController();

      const url = new URL(button.href, window.location.href);
      url.searchParams.set('section_id', this.dataset.sectionId);

      try {
        const response = await fetch(url.toString(), { signal: this.controller.signal });
        if (!response.ok) throw new Error(String(response.status));

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const cards = Array.from(doc.querySelectorAll('[data-articles] > *'));
        const next = doc.querySelector('a[data-load-more]');
        const mobile = window.matchMedia('(max-width: 749px)').matches;

        cards.forEach((card, index) => {
          if (mobile && index === 0) card.classList.remove('blog__item--overflow');
          this.grid.appendChild(card);
        });
        this.grid.dispatchEvent(new CustomEvent('reveal:scan', { bubbles: true }));

        const pending = mobile && this.hiddenCards().length > 0;

        if (next) {
          button.setAttribute('href', next.getAttribute('href'));
        } else if (!pending) {
          const wrapper = button.closest('.blog__more') || button;
          wrapper.remove();
        } else {
          button.removeAttribute('href');
          button.setAttribute('role', 'button');
          button.setAttribute('tabindex', '0');
        }

        if (cards[0] && typeof cards[0].focus === 'function') cards[0].focus();
      } catch (error) {
        if (error.name !== 'AbortError') window.location.assign(button.href);
      } finally {
        this.loading = false;
        button.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('blog-listing')) {
    customElements.define('blog-listing', BlogListing);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["booking-calendar"] && !Shopify.designMode) return;
  try {
    
  class BookingCalendar extends HTMLElement {
    constructor() {
      super();
      this.onFrameLoad = this.onFrameLoad.bind(this);
      this.onFrameStyle = this.onFrameStyle.bind(this);
      this.onIntersect = this.onIntersect.bind(this);
    }

    connectedCallback() {
      this.frame = this.querySelector('[data-frame]');
      if (!this.frame) return;

      this.frame.addEventListener('load', this.onFrameLoad);
      this.styleObserver = new MutationObserver(this.onFrameStyle);
      this.styleObserver.observe(this.frame, { attributes: true, attributeFilter: ['style'] });

      if ('IntersectionObserver' in window) {
        this.viewObserver = new IntersectionObserver(this.onIntersect, { rootMargin: '100% 0px' });
        this.viewObserver.observe(this);
      } else {
        this.activate();
      }
    }

    disconnectedCallback() {
      if (this.frame) this.frame.removeEventListener('load', this.onFrameLoad);
      if (this.styleObserver) this.styleObserver.disconnect();
      if (this.viewObserver) this.viewObserver.disconnect();
      clearTimeout(this.fallbackTimer);
    }

    onIntersect(entries) {
      if (entries.some((entry) => entry.isIntersecting)) this.activate();
    }

    activate() {
      if (this.activated) return;
      this.activated = true;
      if (this.viewObserver) this.viewObserver.disconnect();

      this.frame.src = this.frame.dataset.src;

      const src = this.dataset.embedScript;
      if (typeof window.iFrameResize === 'function') {
        window.iFrameResize({ checkOrigin: false, heightCalculationMethod: 'offset' }, this.frame);
      } else if (src && !document.querySelector('script[src="' + src + '"]')) {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        document.head.appendChild(script);
      }
    }

    onFrameLoad() {
      if (!this.activated || this.ready) return;
      clearTimeout(this.fallbackTimer);
      this.fallbackTimer = setTimeout(() => this.showFallback(), 6000);
    }

    onFrameStyle() {
      const style = this.frame.style;
      if (this.ready || !style.height || style.visibility === 'hidden') return;

      this.ready = true;
      clearTimeout(this.fallbackTimer);
      this.styleObserver.disconnect();
      this.classList.remove('booking-calendar--fallback');
      this.classList.add('booking-calendar--ready');
    }

    showFallback() {
      if (this.ready) return;
      this.styleObserver.disconnect();
      this.frame.removeAttribute('style');
      this.classList.add('booking-calendar--fallback');
    }
  }

  if (!customElements.get('booking-calendar')) {
    customElements.define('booking-calendar', BookingCalendar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onAdded = this.onAdded.bind(this);
      this.onCloseRequest = this.onCloseRequest.bind(this);
      this.closeTimer = null;
      this.closeHandler = null;
      this.trigger = null;
    }

    connectedCallback() {
      this.panel = this.querySelector('dialog');
      this.form = this.querySelector('cart-form');
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('cart:added', this.onAdded);
      document.addEventListener('cart-drawer:close', this.onCloseRequest);
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('cart:added', this.onAdded);
      document.removeEventListener('cart-drawer:close', this.onCloseRequest);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      this.cancelClose();
    }

    get header() {
      return document.querySelector('site-header');
    }

    get isOpen() {
      return this.classList.contains('is-open');
    }

    get closeButton() {
      return this.querySelector('[data-cart-close]:not(.cart-drawer__backdrop)');
    }

    reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    onDocumentClick(event) {
      const toggle = event.target.closest ? event.target.closest('[data-cart-toggle]') : null;
      if (!toggle) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      if (this.isOpen) {
        this.close();
        return;
      }
      this.trigger = toggle;
      this.open();
    }

    onClick(event) {
      if (event.target.closest && event.target.closest('[data-cart-close]')) this.close();
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }
      if (event.key === 'Tab') this.trapFocus(event);
    }

    async onAdded(event) {
      if (document.querySelector('[data-cart-page]')) return;

      const inside = event && event.target instanceof Node && this.contains(event.target);
      if (!inside) {
        const active = document.activeElement;
        this.trigger = active && active !== document.body && !this.contains(active) ? active : null;
      }

      if (this.form && typeof this.form.refresh === 'function') {
        try {
          await this.form.refresh();
        } catch (error) {
          return;
        }
      }

      if (this.isOpen) {
        if (!this.contains(document.activeElement)) this.panel.focus();
        return;
      }
      this.open();
    }

    onCloseRequest() {
      this.close();
    }

    open() {
      if (this.isOpen || !this.panel) return;
      this.cancelClose();

      const header = this.header;
      if (header && typeof header.closeAll === 'function') header.closeAll();
      if (header && typeof header.setCartOpen === 'function') header.setCartOpen(true);

      this.classList.add('is-visible');
      if (!this.panel.open) this.panel.show();

      const reveal = () => {
        this.classList.add('is-open');
        this.focusFirst();
      };
      if (this.reducedMotion()) {
        reveal();
        return;
      }
      requestAnimationFrame(() => {
        requestAnimationFrame(reveal);
      });
    }

    close() {
      if (!this.isOpen || !this.panel) return;
      this.cancelClose();
      this.classList.remove('is-open');

      const header = this.header;
      if (header && typeof header.setCartOpen === 'function') header.setCartOpen(false);

      const done = () => {
        this.cancelClose();
        this.classList.remove('is-visible');
        if (this.panel.open) this.panel.close();
        if (this.trigger && document.contains(this.trigger)) this.trigger.focus();
      };

      if (this.reducedMotion()) {
        done();
        return;
      }
      this.closeHandler = (event) => {
        if (event.target !== this.panel) return;
        done();
      };
      this.panel.addEventListener('transitionend', this.closeHandler);
      this.closeTimer = setTimeout(done, 500);
    }

    cancelClose() {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
      if (this.closeHandler && this.panel) {
        this.panel.removeEventListener('transitionend', this.closeHandler);
        this.closeHandler = null;
      }
    }

    focusable() {
      const selector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
      return Array.from(this.panel.querySelectorAll(selector)).filter((el) => el.offsetParent !== null);
    }

    focusFirst() {
      const close = this.closeButton;
      if (close && close.offsetParent !== null) {
        close.focus();
        return;
      }
      const items = this.focusable();
      (items[0] || this.panel).focus();
    }

    trapFocus(event) {
      const items = this.focusable();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      const active = document.activeElement;

      if (event.shiftKey && (active === first || active === this.panel)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CollectionListing extends HTMLElement {
    constructor() {
      super();
      this.loading = false;
      this.onClick = this.onClick.bind(this);
      this.onPopstate = this.onPopstate.bind(this);
    }

    connectedCallback() {
      this.main = this.querySelector('[data-main]');
      this.results = this.querySelector('[data-results]');
      this.status = this.querySelector('[data-listing-status]');
      this.addEventListener('click', this.onClick);
      window.addEventListener('popstate', this.onPopstate);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('popstate', this.onPopstate);
      if (this.controller) this.controller.abort();
    }

    get grid() {
      return this.querySelector('[data-products]');
    }

    onClick(event) {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const chip = event.target.closest ? event.target.closest('a.collection__chip') : null;
      if (chip) {
        event.preventDefault();
        if (chip.hasAttribute('aria-current')) return;
        this.show(chip.href, true);
        return;
      }

      const button = event.target.closest ? event.target.closest('a[data-load-more]') : null;
      if (!button || !this.grid) return;
      event.preventDefault();
      if (this.loading) return;
      this.loadMore(button);
    }

    onPopstate() {
      if (!this.results) return;
      this.show(window.location.href, false);
    }

    sectionUrl(href) {
      const url = new URL(href, window.location.href);
      url.searchParams.set('section_id', this.dataset.sectionId);
      return url.toString();
    }

    async fetchSection(href) {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const response = await fetch(this.sectionUrl(href), { signal: this.controller.signal });
      if (!response.ok) throw new Error(String(response.status));
      const html = await response.text();
      return new DOMParser().parseFromString(html, 'text/html');
    }

    async show(href, push) {
      if (!this.results || !this.main) return;
      this.loading = true;
      this.main.setAttribute('aria-busy', 'true');
      this.announce(this.dataset.loadingLabel);

      try {
        const doc = await this.fetchSection(href);
        const results = doc.querySelector('[data-results]');
        if (!results) throw new Error('missing results');

        this.results.replaceChildren(...Array.from(results.childNodes));
        this.updateHeading(doc);
        this.markCurrent(href);
        if (push) window.history.pushState({ collection: href }, '', href);

        this.results.dispatchEvent(new CustomEvent('reveal:scan', { bubbles: true }));
        this.scrollIntoViewIfAbove();
        this.announceCount();
      } catch (error) {
        if (error.name !== 'AbortError') window.location.assign(href);
        return;
      } finally {
        this.loading = false;
        this.main.removeAttribute('aria-busy');
      }
    }

    updateHeading(doc) {
      const heading = this.querySelector('[data-heading]');
      const next = doc.querySelector('[data-heading]');
      if (!heading || !next) return;
      const previous = heading.textContent.trim();
      const text = next.textContent.trim();
      if (previous === text) return;
      heading.textContent = text;
      if (previous) document.title = document.title.replace(previous, text);
    }

    markCurrent(href) {
      const target = new URL(href, window.location.href).pathname;
      this.querySelectorAll('a.collection__chip').forEach((chip) => {
        const path = new URL(chip.href, window.location.href).pathname;
        if (path === target) {
          chip.setAttribute('aria-current', 'page');
        } else {
          chip.removeAttribute('aria-current');
        }
      });
    }

    scrollIntoViewIfAbove() {
      const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      const top = this.getBoundingClientRect().top;
      if (top >= header) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: window.scrollY + top - header, behavior: reduce ? 'auto' : 'smooth' });
    }

    async loadMore(button) {
      this.loading = true;
      button.setAttribute('aria-busy', 'true');

      try {
        const doc = await this.fetchSection(button.href);
        const items = Array.from(doc.querySelectorAll('[data-products] > *'));
        const next = doc.querySelector('a[data-load-more]');
        const grid = this.grid;

        items.forEach((item) => grid.appendChild(item));
        grid.dispatchEvent(new CustomEvent('reveal:scan', { bubbles: true }));

        if (next) {
          button.setAttribute('href', next.getAttribute('href'));
        } else {
          const wrapper = button.closest('.collection__more') || button;
          wrapper.remove();
        }

        const link = items[0] ? items[0].querySelector('.product-card__name a') : null;
        if (link && typeof link.focus === 'function') link.focus();
        this.announceCount();
      } catch (error) {
        if (error.name !== 'AbortError') window.location.assign(button.href);
      } finally {
        this.loading = false;
        button.removeAttribute('aria-busy');
      }
    }

    announceCount() {
      const label = this.dataset.resultsLabel;
      if (!label) return;
      const count = this.querySelectorAll('.collection__item').length;
      this.announce(label.replace('__count__', String(count)));
    }

    announce(text) {
      if (!this.status || !text) return;
      this.status.textContent = '';
      window.requestAnimationFrame(() => {
        this.status.textContent = text;
      });
    }
  }

  if (!customElements.get('collection-listing')) {
    customElements.define('collection-listing', CollectionListing);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  class CustomerReviews extends HTMLElement {
    constructor() {
      super();
      this.onSubmit = this.onSubmit.bind(this);
      this.onInput = this.onInput.bind(this);
      this.onControlChange = this.onControlChange.bind(this);
      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onScrollerClick = this.onScrollerClick.bind(this);
    }

    connectedCallback() {
      this.endpoint = this.dataset.endpoint;
      this.productId = this.dataset.productId;
      this.reviewsEndpoint = this.dataset.reviewsEndpoint;
      this.perPage = parseInt(this.dataset.perPage, 10) || 50;
      this.truncate = parseInt(this.dataset.truncate, 10) || 380;
      this.labels = {
        more: this.dataset.labelMore || '',
        less: this.dataset.labelLess || '',
        loading: this.dataset.labelLoading || '',
        empty: this.dataset.labelEmpty || '',
        error: this.dataset.labelError || '',
        rating: this.dataset.labelRating || '',
        photo: this.dataset.labelPhoto || '',
        score: this.dataset.labelScore || '',
        countOne: this.dataset.labelCountOne || '',
        countMany: this.dataset.labelCountMany || ''
      };

      this.form = this.querySelector('[data-search-form]');
      this.searchInput = this.querySelector('[data-search-input]');
      this.sort = this.querySelector('[data-sort]');
      this.filters = this.querySelector('[data-filters]');
      this.status = this.querySelector('[data-status]');
      this.progress = this.querySelector('scroll-progress');
      this.scroller = this.querySelector('[data-scroller]');
      this.template = this.querySelector('[data-review-template]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.debounce = null;
      this.controller = null;

      if (!this.endpoint || !this.scroller || !this.template) return;

      if (this.form) this.form.addEventListener('submit', this.onSubmit);
      if (this.searchInput) this.searchInput.addEventListener('input', this.onInput);
      if (this.sort) this.sort.addEventListener('change', this.onControlChange);
      if (this.filters) this.filters.addEventListener('change', this.onControlChange);
      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNext);
      this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
      this.scroller.addEventListener('click', this.onScrollerClick);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.syncRowHeight());
        this.resizeObserver.observe(this.scroller);
      }

      this.load();
    }

    disconnectedCallback() {
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);
      if (this.searchInput) this.searchInput.removeEventListener('input', this.onInput);
      if (this.sort) this.sort.removeEventListener('change', this.onControlChange);
      if (this.filters) this.filters.removeEventListener('change', this.onControlChange);
      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrev);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNext);
      if (this.scroller) {
        this.scroller.removeEventListener('scroll', this.onScroll);
        this.scroller.removeEventListener('click', this.onScrollerClick);
      }
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.scroller) this.clearPhotoTimers();
      clearTimeout(this.debounce);
      clearTimeout(this.fadeTimer);
      if (this.controller) this.controller.abort();
    }

    onSubmit(event) {
      event.preventDefault();
      clearTimeout(this.debounce);
      this.load();
    }

    onInput() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => this.load(), 300);
    }

    onControlChange() {
      this.load();
    }

    onPrev() {
      this.scrollByPage(-1);
    }

    onNext() {
      this.scrollByPage(1);
    }

    onScroll() {
      this.updateArrows();
    }

    onScrollerClick(event) {
      const button = event.target.closest('[data-more]');
      if (!button) return;
      const text = button.closest('[data-text]');
      if (!text) return;
      const expanded = text.dataset.expanded !== 'true';
      const card = text.closest('.customer-reviews__card');
      const photo = card && card.dataset.hasPhoto === 'true' ? card.querySelector('[data-photo]') : null;

      if (!card || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        text.dataset.expanded = expanded ? 'true' : 'false';
        this.applyText(text);
        if (photo) photo.hidden = expanded;
        return;
      }

      this.animateCard(card, text, photo, expanded);
    }

    animateCard(card, text, photo, expanded) {
      clearTimeout(card.animationTimer);

      const from = card.getBoundingClientRect().height;

      text.dataset.expanded = expanded ? 'true' : 'false';
      this.applyText(text);

      if (photo && !expanded) {
        photo.hidden = false;
        photo.setAttribute('data-fading', '');
      }

      card.setAttribute('data-animating', '');
      card.style.height = from + 'px';

      const measure = card.cloneNode(true);
      const clonePhoto = measure.querySelector('[data-photo]');
      if (clonePhoto) clonePhoto.hidden = expanded;
      measure.style.position = 'absolute';
      measure.style.visibility = 'hidden';
      measure.style.height = 'auto';
      measure.style.width = card.getBoundingClientRect().width + 'px';
      card.parentNode.appendChild(measure);
      let to = measure.getBoundingClientRect().height;
      measure.remove();

      const row = parseFloat(this.scroller.style.getPropertyValue('--row-height'));
      if (row) to = Math.max(to, row);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          card.style.height = to + 'px';
          if (photo) {
            if (expanded) {
              photo.setAttribute('data-fading', '');
            } else {
              photo.removeAttribute('data-fading');
            }
          }
        });
      });

      card.animationTimer = setTimeout(() => {
        card.style.removeProperty('height');
        card.removeAttribute('data-animating');
        if (photo) {
          photo.hidden = expanded;
          if (!expanded) photo.removeAttribute('data-fading');
        }
        this.syncRowHeight();
      }, 400);
    }

    currentFilter() {
      const checked = this.filters ? this.filters.querySelector('input:checked') : null;
      return checked ? checked.value : 'all';
    }

    load() {
      clearTimeout(this.fadeTimer);
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();

      const sortValue = this.sort ? this.sort.value : 'date:desc';
      const parts = sortValue.split(':');
      const body = {
        domain_key: this.productId,
        page: 1,
        per_page: this.perPage,
        sortings: [{ sort_by: parts[0] || 'date', ascending: parts[1] === 'asc' }]
      };
      if (this.currentFilter() === 'media') body.pictured = true;
      const query = this.searchInput ? this.searchInput.value.trim() : '';
      if (query) body.free_text_search = query;

      if (this.scroller.childElementCount) {
        this.scroller.setAttribute('data-updating', '');
      } else {
        this.setStatus(this.labels.loading);
      }

      const unfiltered = !query && this.currentFilter() === 'all';
      const url = new URL(this.reviewsEndpoint);
      url.searchParams.set('page', '1');
      url.searchParams.set('per_page', String(this.perPage));
      url.searchParams.set('sort', parts[0] || 'date');
      url.searchParams.set('direction', parts[1] === 'asc' ? 'asc' : 'desc');

      fetch(unfiltered ? url.toString() : this.endpoint, unfiltered ? {
        signal: this.controller.signal
      } : {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        signal: this.controller.signal
      })
        .then((response) => {
          if (!response.ok) throw new Error(String(response.status));
          return response.json();
        })
        .then((data) => {
          const response = data && data.response;
          if (!response || !Array.isArray(response.reviews) || (data.status && data.status.code !== 200)) {
            throw new Error('Invalid reviews response');
          }
          const reviews = response.reviews;
          if (unfiltered) this.updateSummary(response.bottomline, reviews);
          this.render(reviews);
          this.setStatus(reviews.length ? '' : this.labels.empty);
        })
        .catch((error) => {
          if (error && error.name === 'AbortError') return;
          if (this.dataset.reviewState === 'pending') this.hidden = true;
          this.scroller.removeAttribute('data-updating');
          this.setStatus(this.labels.error);
        });
    }

    updateSummary(bottomline, reviews) {
      if (!bottomline || bottomline.total_review == null || bottomline.average_score == null) {
        throw new Error('Missing review totals');
      }
      const total = Number(bottomline.total_review);
      const average = Number(bottomline.average_score);
      if (!Number.isInteger(total) || total < 0 || !Number.isFinite(average) ||
          (total > 0 && (average < 1 || average > 5 || !reviews.length))) {
        throw new Error('Invalid review totals');
      }
      this.totalReviews = total;
      this.classList.toggle('customer-reviews--single', total === 1);
      this.dataset.reviewState = total ? 'ready' : 'empty';
      this.hidden = total === 0;
      const score = String(Math.round(average * 10) / 10);
      this.querySelector('[data-summary-score]').textContent = this.labels.score.replace('__SCORE__', score);
      this.querySelector('[data-summary-rating]').textContent = this.labels.rating.replace('__SCORE__', score);
      this.querySelector('[data-summary-count]').textContent =
        (total === 1 ? this.labels.countOne : this.labels.countMany).replace('__COUNT__', String(total));
      this.querySelectorAll('.customer-reviews__stars--summary .customer-reviews__star').forEach((star, index) => {
        star.classList.toggle('customer-reviews__star--empty', index >= Math.round(average));
      });
      this.dispatchEvent(new CustomEvent('reveal:scan', { bubbles: true }));
    }

    setStatus(text) {
      if (!this.status) return;
      this.status.textContent = text;
      this.status.hidden = !text;
    }

    render(reviews) {
      const swap = () => {
        this.clearPhotoTimers();
        this.scroller.textContent = '';
        const fragment = document.createDocumentFragment();
        reviews.forEach((review) => fragment.appendChild(this.buildCard(review)));
        this.scroller.appendChild(fragment);
        this.scroller.scrollLeft = 0;
        this.syncRowHeight();
        this.refreshProgress();
        this.updateArrows();
        this.scroller.removeAttribute('data-updating');
      };

      if (!this.scroller.hasAttribute('data-updating')) {
        swap();
        return;
      }

      clearTimeout(this.fadeTimer);
      this.fadeTimer = setTimeout(swap, 300);
    }

    buildCard(review) {
      const card = this.template.content.firstElementChild.cloneNode(true);
      const name = review.user && review.user.display_name ? review.user.display_name : '';
      const score = Math.round(Number(review.score) || 0);

      card.querySelector('[data-name]').textContent = name;

      const date = card.querySelector('[data-date]');
      date.textContent = this.formatDate(review.created_at);
      if (review.created_at) date.dateTime = String(review.created_at).slice(0, 10);

      card.querySelectorAll('[data-stars] .customer-reviews__star').forEach((star, index) => {
        star.classList.toggle('customer-reviews__star--empty', index >= score);
      });
      card.querySelector('[data-rating]').textContent = this.labels.rating.replace('__SCORE__', String(score));

      const title = card.querySelector('[data-title]');
      if (review.title) {
        title.textContent = review.title.replace(/\bVim\b/g, 'VIM');
      } else {
        title.remove();
      }

      const text = card.querySelector('[data-text]');
      const content = (review.content || '').replace(/\bVim\b/g, 'VIM').trim();
      if (this.totalReviews !== 1 && content.length > this.truncate) {
        text.dataset.full = content;
        text.dataset.expanded = 'false';
        this.applyText(text);
      } else {
        text.textContent = content;
      }

      const photo = card.querySelector('[data-photo]');
      const image = Array.isArray(review.images_data) && review.images_data.length ? review.images_data[0] : null;
      if (image && (image.thumb_url || image.original_url)) {
        photo.src = image.thumb_url || image.original_url;
        photo.alt = this.labels.photo.replace('__NAME__', name);
        photo.hidden = false;
        card.dataset.hasPhoto = 'true';
      }

      return card;
    }

    applyText(text) {
      const full = text.dataset.full || '';
      const expanded = text.dataset.expanded === 'true';
      let visible = full;
      if (!expanded) {
        const cut = full.slice(0, this.truncate);
        const space = cut.lastIndexOf(' ');
        visible = (space > this.truncate * 0.6 ? cut.slice(0, space) : cut) + '... ';
      } else {
        visible = full + ' ';
      }
      text.textContent = visible;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'customer-reviews__more';
      button.setAttribute('data-more', '');
      button.textContent = expanded ? this.labels.less : this.labels.more;
      text.appendChild(button);
    }

    clearPhotoTimers() {
      this.scroller.querySelectorAll('.customer-reviews__card').forEach((card) => clearTimeout(card.animationTimer));
    }

    syncRowHeight() {
      const cards = Array.from(this.scroller.querySelectorAll('.customer-reviews__card'));
      this.scroller.style.removeProperty('--row-height');
      if (this.totalReviews === 1) return;
      let max = 0;
      cards.forEach((card) => {
        const text = card.querySelector('[data-text]');
        if (text && text.dataset.expanded === 'true') return;
        max = Math.max(max, card.offsetHeight);
      });
      if (max) this.scroller.style.setProperty('--row-height', max + 'px');
    }

    formatDate(value) {
      if (!value) return '';
      const date = new Date(value);
      if (isNaN(date.getTime())) return '';
      const pad = (n) => String(n).padStart(2, '0');
      return pad(date.getMonth() + 1) + '/' + pad(date.getDate()) + '/' + String(date.getFullYear()).slice(-2);
    }

    scrollByPage(direction) {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.scroller.scrollBy({
        left: direction * this.scroller.clientWidth,
        behavior: reduced ? 'auto' : 'smooth'
      });
    }

    refreshProgress() {
      if (!this.progress) return;
      if (typeof this.progress.onResize === 'function') {
        this.progress.onResize();
      } else {
        this.scroller.dispatchEvent(new Event('scroll'));
      }
    }

    updateArrows() {
      const max = this.scroller.scrollWidth - this.scroller.clientWidth;
      const left = this.scroller.scrollLeft;
      if (this.prevButton) this.prevButton.disabled = left <= 1;
      if (this.nextButton) this.nextButton.disabled = max <= 1 || left >= max - 1;
    }
  }

  if (!customElements.get('customer-reviews')) {
    customElements.define('customer-reviews', CustomerReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-media"] && !Shopify.designMode) return;
  try {
    
  class EditorialMedia extends HTMLElement {
    constructor() {
      super();
      this.frame = null;
      this.inView = false;
      this.update = this.update.bind(this);
      this.schedule = this.schedule.bind(this);
      this.onEnvironmentChange = this.onEnvironmentChange.bind(this);
    }

    connectedCallback() {
      this.figures = Array.from(this.querySelectorAll('[data-parallax]'));
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.desktopQuery = window.matchMedia('(min-width: 750px)');
      this.motionQuery.addEventListener('change', this.onEnvironmentChange);
      this.desktopQuery.addEventListener('change', this.onEnvironmentChange);
      this.observer = new IntersectionObserver((entries) => {
        this.inView = entries[0].isIntersecting;
        this.schedule();
      });
      this.observer.observe(this);
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule, { passive: true });
      this.onEnvironmentChange();
    }

    disconnectedCallback() {
      this.observer.disconnect();
      this.motionQuery.removeEventListener('change', this.onEnvironmentChange);
      this.desktopQuery.removeEventListener('change', this.onEnvironmentChange);
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      if (this.frame) window.cancelAnimationFrame(this.frame);
    }

    onEnvironmentChange() {
      const enabled = !this.motionQuery.matches && this.desktopQuery.matches;
      this.classList.toggle('is-parallax', enabled);
      if (!enabled) {
        this.figures.forEach((figure) => figure.style.removeProperty('--parallax-y'));
      }
      this.schedule();
    }

    schedule() {
      if (!this.inView || !this.classList.contains('is-parallax') || this.frame) return;
      this.frame = window.requestAnimationFrame(this.update);
    }

    update() {
      this.frame = null;
      if (this.figures.length < 2) return;

      const first = this.figures[0];
      const second = this.figures[1];
      if (first.offsetParent === null || second.offsetParent === null) {
        this.figures.forEach((figure) => figure.style.setProperty('--parallax-y', '0px'));
        return;
      }

      const firstMedia = first.querySelector('.media');
      const secondMedia = second.querySelector('.media');
      const firstCentre = first.offsetTop + firstMedia.offsetTop + firstMedia.offsetHeight / 2;
      const secondCentre = second.offsetTop + secondMedia.offsetTop + secondMedia.offsetHeight / 2;
      const gap = secondCentre - firstCentre;
      if (gap === 0) {
        this.figures.forEach((figure) => figure.style.setProperty('--parallax-y', '0px'));
        return;
      }

      const viewport = window.innerHeight;
      const section = this.getBoundingClientRect();
      const travel = (viewport + section.height) / 2;
      const entered = viewport - section.top;
      const progress = Math.max(0, entered / travel);

      first.style.setProperty('--parallax-y', (gap * progress * 0.5).toFixed(1) + 'px');
      second.style.setProperty('--parallax-y', (-gap * progress * 0.5).toFixed(1) + 'px');
    }
  }

  if (!customElements.get('editorial-media')) {
    customElements.define('editorial-media', EditorialMedia);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    static SCROLL_THRESHOLD = 8;
    static DEBOUNCE = 250;

    constructor() {
      super();
      this.onScroll = this.onScroll.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onInput = this.onInput.bind(this);
      this.lastScrollY = 0;
      this.timer = null;
      this.controller = null;
    }

    connectedCallback() {
      this.lastScrollY = window.scrollY;
      this.addEventListener('click', this.onClick);
      document.addEventListener('keydown', this.onKeydown);

      this.input = this.querySelector('[data-search-input]');
      this.results = this.querySelector('[data-search-results]');
      this.grid = this.querySelector('[data-search-grid]');
      this.burgerLabel = this.querySelector('[data-burger-label]');
      this.static = this.querySelector('[data-search-static]');
      this.status = this.querySelector('[data-search-status]');

      if (this.input && this.hasAttribute('data-predictive')) {
        this.input.addEventListener('input', this.onInput);
      }

      if (this.classList.contains('header--fixed')) {
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('click', this.onClick);
      if (this.input) this.input.removeEventListener('input', this.onInput);
      if (this.timer) clearTimeout(this.timer);
      if (this.controller) this.controller.abort();
    }

    onScroll() {
      const y = window.scrollY;
      const goingDown = y > this.lastScrollY;
      const past = y > SiteHeader.SCROLL_THRESHOLD;
      const open =
        this.classList.contains('header--menu-open') ||
        this.classList.contains('header--search-open') ||
        this.classList.contains('header--submenu-open') ||
        this.classList.contains('header--cart-open');

      this.classList.toggle('header--hidden', goingDown && past && !open);
      this.classList.toggle('header--scrolled', past);
      this.lastScrollY = y;
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;
      this.closeAll();
    }

    onClick(event) {
      const submenu = event.target.closest('[data-submenu-toggle]');
      if (submenu) {
        this.toggleSubmenu(submenu);
        return;
      }

      const search = event.target.closest('[data-search-toggle]');
      if (search) {
        event.preventDefault();
        this.toggleSearch(search);
        return;
      }

      if (event.target.closest('[data-search-close]')) {
        this.closeAll();
        return;
      }

      const drawer = event.target.closest('[data-drawer-toggle]');
      if (drawer) {
        this.toggleDrawer(drawer);
      }
    }

    toggleSubmenu(button) {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      const open = button.getAttribute('aria-expanded') === 'true';
      this.closeAll();
      if (open || !panel) return;

      button.setAttribute('aria-expanded', 'true');
      this.openPanel(panel);
      this.classList.add('header--submenu-open');
    }

    toggleSearch(trigger) {
      const panel = this.querySelector('.header__panel--search');
      const open = this.classList.contains('header--search-open');
      this.closeAll();
      if (open || !panel) return;

      this.openPanel(panel);
      this.classList.add('header--search-open');
      this.setBurgerLabel(true);
      this.querySelectorAll('[data-search-toggle]').forEach((el) => el.setAttribute('aria-expanded', 'true'));
      if (this.input) this.input.focus();
      if (trigger) this.trigger = trigger;
    }

    toggleDrawer(button) {
      if (this.classList.contains('header--cart-open')) {
        document.dispatchEvent(new CustomEvent('cart-drawer:close'));
        return;
      }
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      const open = button.getAttribute('aria-expanded') === 'true';
      const searching = this.classList.contains('header--search-open');
      this.closeAll();
      if (open || searching || !panel) return;

      button.setAttribute('aria-expanded', 'true');
      this.openDrawer(panel);
      this.classList.add('header--menu-open');
      this.setBurgerLabel(true);
    }

    reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    openPanel(panel) {
      this.cancelClose(panel);
      panel.hidden = false;
      if (this.reducedMotion()) {
        panel.classList.add('header__panel--open');
        return;
      }
      requestAnimationFrame(() => {
        requestAnimationFrame(() => panel.classList.add('header__panel--open'));
      });
    }

    openDrawer(panel) {
      this.cancelClose(panel);
      panel.hidden = false;
      if (this.reducedMotion()) {
        panel.classList.add('header__drawer--open');
        return;
      }
      requestAnimationFrame(() => {
        requestAnimationFrame(() => panel.classList.add('header__drawer--open'));
      });
    }

    cancelClose(panel) {
      if (panel.closeTimer) {
        clearTimeout(panel.closeTimer);
        panel.closeTimer = null;
      }
      if (panel.closeHandler) {
        panel.removeEventListener('transitionend', panel.closeHandler);
        panel.closeHandler = null;
      }
    }

    closeAll() {
      if (this.grid) this.grid.hidden = true;
      if (this.input) this.input.value = '';
      if (this.results) this.results.innerHTML = '';
      this.querySelectorAll('.header__panel').forEach((panel) => {
        if (panel.hidden) return;
        this.cancelClose(panel);
        panel.classList.remove('header__panel--open');

        const done = () => {
          this.cancelClose(panel);
          panel.hidden = true;
        };

        if (this.reducedMotion()) { done(); return; }

        panel.closeHandler = (event) => {
          if (event.target !== panel) return;
          done();
        };
        panel.addEventListener('transitionend', panel.closeHandler);
        panel.closeTimer = setTimeout(done, 500);
      });
      this.querySelectorAll('.header__drawer').forEach((panel) => {
        if (panel.hidden) return;
        this.cancelClose(panel);
        panel.classList.remove('header__drawer--open');

        const done = () => {
          this.cancelClose(panel);
          panel.hidden = true;
        };

        if (this.reducedMotion()) { done(); return; }

        panel.closeHandler = (event) => {
          if (event.target !== panel) return;
          done();
        };
        panel.addEventListener('transitionend', panel.closeHandler);
        panel.closeTimer = setTimeout(done, 500);
      });
      this.querySelectorAll('[aria-expanded="true"]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });
      this.classList.remove(
        'header--menu-open',
        'header--search-open',
        'header--submenu-open',
        'header--results'
      );
      this.setBurgerLabel(false);
    }

    setCartOpen(open) {
      this.classList.toggle('header--cart-open', open);
      if (open) this.classList.remove('header--hidden');
      this.setBurgerLabel(open);
    }

    setBurgerLabel(closing) {
      if (!this.burgerLabel) return;
      const key = closing ? 'data-label-close' : 'data-label-menu';
      this.burgerLabel.textContent = this.getAttribute(key) || this.burgerLabel.textContent;
    }

    onInput() {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => this.search(), SiteHeader.DEBOUNCE);
    }

    async search() {
      const terms = this.input.value.trim();

      if (terms.length < 2) {
        if (this.grid) this.grid.hidden = true;
        this.results.innerHTML = '';
        this.classList.remove('header--results');
        return;
      }

      if (this.controller) this.controller.abort();
      this.controller = new AbortController();

      const base = this.getAttribute('data-predictive-url') || '/search/suggest';
      const limit = parseInt(this.getAttribute('data-predictive-limit'), 10) || 6;
      const pinned = this.pinnedHandles().length;
      const ask = Math.min(limit + pinned, 10);
      const url =
        base +
        '?q=' +
        encodeURIComponent(terms) +
        '&resources[type]=product,article' +
        '&resources[limit]=' +
        encodeURIComponent(ask) +
        '&resources[limit_scope]=each' +
        '&section_id=predictive-search';

      try {
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error(response.statusText);
        const text = await response.text();
        this.render(text, terms);
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.results.hidden = true;
        this.results.innerHTML = '';
      }
    }

    render(html, terms) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const payload = doc.querySelector('[data-predictive-payload]');
      if (!payload) {
        this.results.hidden = true;
        return;
      }

      this.results.innerHTML = payload.innerHTML;
      this.dropPinned();
      if (this.grid) this.grid.hidden = false;
      this.classList.add('header--results');
      this.highlight(terms);

      const count = this.results.querySelectorAll('a').length;
      if (this.status) {
        this.status.textContent = count + ' ' + (this.getAttribute('data-results-label') || 'results');
      }
    }

    pinnedHandles() {
      return (this.getAttribute('data-pinned') || '')
        .split(',')
        .map((handle) => handle.trim())
        .filter(Boolean);
    }

    dropPinned() {
      const pinned = this.pinnedHandles();
      if (!pinned.length) return;

      pinned.forEach((handle) => {
        const link = this.results.querySelector('[data-handle="' + handle + '"]');
        if (link) link.remove();
      });

      this.results.querySelectorAll('.search-column').forEach((column) => {
        if (!column.querySelector('a')) column.remove();
      });
    }

    highlight(terms) {
      const needle = terms.toLowerCase();
      this.results.querySelectorAll('[data-highlight]').forEach((node) => {
        const text = node.textContent;
        const index = text.toLowerCase().indexOf(needle);
        if (index === -1) return;

        const mark = document.createElement('mark');
        mark.textContent = text.slice(index, index + terms.length);
        node.textContent = '';
        node.append(text.slice(0, index), mark, text.slice(index + terms.length));
      });
    }
  }

  if (!customElements.get('site-header')) {
    customElements.define('site-header', SiteHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class VideoPlayer extends HTMLElement {
    constructor() {
      super();
      this.onButtonClick = this.onButtonClick.bind(this);
      this.onPlay = this.onPlay.bind(this);
    }

    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('.video-player__play');
      if (!this.video) return;

      if (this.video.autoplay) {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.video.removeAttribute('autoplay');
          this.video.pause();
          this.video.controls = true;
        }
        return;
      }

      if (!this.button) return;
      this.video.controls = false;
      this.button.hidden = false;
      this.button.addEventListener('click', this.onButtonClick);
      this.video.addEventListener('play', this.onPlay);
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.onButtonClick);
      if (this.video) this.video.removeEventListener('play', this.onPlay);
    }

    onButtonClick() {
      this.video.controls = true;
      const played = this.video.play();
      if (played && played.catch) played.catch(function () {});
    }

    onPlay() {
      this.video.controls = true;
      this.classList.add('is-playing');
    }
  }

  if (!customElements.get('video-player')) {
    customElements.define('video-player', VideoPlayer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  class NewsletterPopup extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.onKeydown = this.onKeydown.bind(this);
      this.close = this.close.bind(this);
    }

    connectedCallback() {
      this.sessionKey = 'newsletter-popup-session';
      this.untilKey = 'newsletter-popup-until';

      const closeButton = this.querySelector('[data-newsletter-close]');
      if (closeButton) {
        closeButton.addEventListener('click', this.close);
      }

      if (window.Shopify && window.Shopify.designMode) {
        this.open();
        return;
      }

      if (this.querySelector('[data-newsletter-success]')) {
        this.open();
        this.suppress();
        return;
      }

      if (this.querySelector('[data-newsletter-errors]')) {
        this.open();
        return;
      }

      if (this.isSuppressed()) {
        return;
      }

      const delay = (Number(this.dataset.delay) || 0) * 1000;
      this.timer = window.setTimeout(() => this.open(), delay);
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      document.removeEventListener('keydown', this.onKeydown);
    }

    open() {
      window.clearTimeout(this.timer);
      this.classList.add('is-open');
      document.addEventListener('keydown', this.onKeydown);
    }

    close() {
      this.classList.remove('is-open');
      document.removeEventListener('keydown', this.onKeydown);
      if (!(window.Shopify && window.Shopify.designMode)) {
        this.suppress();
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
      }
    }

    suppress() {
      try {
        window.sessionStorage.setItem(this.sessionKey, '1');
        const days = Number(this.dataset.frequency) || 0;
        if (days > 0) {
          const until = Date.now() + days * 86400000;
          window.localStorage.setItem(this.untilKey, String(until));
        }
      } catch (error) {
        return;
      }
    }

    isSuppressed() {
      try {
        if (window.sessionStorage.getItem(this.sessionKey)) {
          return true;
        }
        const until = Number(window.localStorage.getItem(this.untilKey));
        return until > 0 && Date.now() < until;
      } catch (error) {
        return false;
      }
    }
  }

  if (!customElements.get('newsletter-popup')) {
    customElements.define('newsletter-popup', NewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class SaunaBuilder extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      const dataEl = this.querySelector('[data-sauna-builder-data]');
      try {
        this.data = JSON.parse(dataEl.textContent);
      } catch (e) {
        this.data = {};
      }
      this.data.steps = this.data.steps || [];
      this.data.variants = this.data.variants || [];
      this.data.combos = this.data.combos || {};
      const comboParts = {};
      Object.keys(this.data.combos).forEach((combo) => {
        comboParts[this.data.combos[combo]] = combo.split('|');
      });
      this.variantKeys = this.data.variants.map((v) =>
        this.data.steps.map((step) => {
          const value = v.options[step.option];
          if (step.part === -1) return value;
          const parts = comboParts[value];
          return parts ? parts[step.part] : null;
        })
      );

      this.steps = Array.from(this.querySelectorAll('[data-builder-step]'));
      this.totalSteps = this.steps.length;
      this.optionCount = this.totalSteps - 1;
      this.idInput = this.querySelector('[data-builder-id]');
      this.priceEl = this.querySelector('[data-builder-price]');
      this.depositEl = this.querySelector('[data-builder-deposit]');
      this.previewImg = this.querySelector('[data-builder-preview]');
      this.previewName = this.querySelector('[data-builder-preview-name]');
      this.previewDesc = this.querySelector('[data-builder-preview-description]');
      this.info = this.querySelector('[data-builder-info]');
      this.summary = this.querySelector('[data-builder-summary]');
      this.progress = this.querySelector('[data-builder-progress]');
      this.nextBtn = this.querySelector('[data-builder-next]');
      this.reserveBtn = this.querySelector('[data-builder-reserve]');
      this.prevBtn = this.querySelector('[data-builder-prev]');
      this.stepCountEl = this.querySelector('[data-builder-step-count]');
      this.stepTemplate = this.stepCountEl ? this.stepCountEl.dataset.stepTemplate : '';
      this.refundDialog = this.querySelector('[data-builder-refund-dialog]');
      this.refundOpen = this.querySelector('[data-builder-refund-open]');

      this.cartForm = this.querySelector('form[action*="/cart/add"]');
      if (this.cartForm) {
        if (!this.onReserve) this.onReserve = this.submitReserve.bind(this);
        this.cartForm.addEventListener('submit', this.onReserve);
      }

      this.radios = [];
      for (let i = 0; i < this.optionCount; i++) {
        this.radios[i] = Array.from(this.querySelectorAll('input[name="builder-step-' + i + '"]'));
      }
      this.activeIndex = 0;
      this.available = true;
      this.variant = null;
      this.selected = [];
      for (let i = 0; i < this.optionCount; i++) {
        const checked = this.radios[i].find((radio) => radio.checked);
        this.selected[i] = checked ? checked.dataset.key : null;
      }

      this.onRadioChange = (event) => {
        const radio = event.target;
        const i = parseInt(radio.dataset.step, 10);
        this.selected[i] = radio.dataset.key;
        this.syncAvailability();
        this.updateVariant();
        this.updateDeltas();
      };
      this.querySelectorAll('[data-builder-radio]').forEach((radio) => {
        radio.addEventListener('change', this.onRadioChange);
      });

      this.gridNavs = [];
      this.steps.forEach((step) => {
        const grid = step.querySelector('.sauna-builder__grid');
        const prev = step.querySelector('[data-builder-grid-prev]');
        const next = step.querySelector('[data-builder-grid-next]');
        if (!grid || !prev || !next) return;
        const nav = { grid, prev, next };
        nav.update = () => {
          const max = grid.scrollWidth - grid.clientWidth;
          prev.disabled = grid.scrollLeft <= 1;
          next.disabled = max <= 1 || grid.scrollLeft >= max - 1;
        };
        nav.onPrev = () => this.scrollGrid(grid, -1);
        nav.onNext = () => this.scrollGrid(grid, 1);
        grid.addEventListener('scroll', nav.update, { passive: true });
        prev.addEventListener('click', nav.onPrev);
        next.addEventListener('click', nav.onNext);
        this.gridNavs.push(nav);
      });
      this.onResize = () => this.updateGridNavs();
      window.addEventListener('resize', this.onResize, { passive: true });

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.showStep(this.activeIndex + 1));
      }
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.showStep(this.activeIndex - 1));
      }

      if (this.refundOpen && this.refundDialog && typeof this.refundDialog.showModal === 'function') {
        this.refundOpen.addEventListener('click', (event) => {
          event.preventDefault();
          this.refundDialog.showModal();
        });
        const closeBtn = this.refundDialog.querySelector('[data-builder-refund-close]');
        if (closeBtn) {
          closeBtn.addEventListener('click', () => this.refundDialog.close());
        }
        this.refundDialog.addEventListener('click', (event) => {
          if (event.target === this.refundDialog) this.refundDialog.close();
        });
      }

      this.infoDialog = this.querySelector('[data-builder-info-dialog]');
      if (this.infoDialog && typeof this.infoDialog.showModal === 'function') {
        this.infoTitle = this.infoDialog.querySelector('[data-builder-info-title]');
        this.infoDescription = this.infoDialog.querySelector('[data-builder-info-description]');
        this.infoMedia = this.infoDialog.querySelector('[data-builder-info-media]');
        this.infoImage = this.infoDialog.querySelector('[data-builder-info-image]');

        this.querySelectorAll('[data-builder-info-open]').forEach((btn) => {
          btn.addEventListener('click', () => this.openInfo(btn));
        });

        const infoClose = this.infoDialog.querySelector('[data-builder-info-close]');
        if (infoClose) {
          infoClose.addEventListener('click', () => this.infoDialog.close());
        }
        this.infoDialog.addEventListener('click', (event) => {
          if (event.target === this.infoDialog) this.infoDialog.close();
        });
      }

      this.fadeTimers = new Map();
      this.previewKey = null;
      this.syncAvailability();
      this.updateVariant();
      this.updateDeltas();
      this.showStep(0);
      this.updatePreview(true);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      clearTimeout(this.leaveTimer);
      (this.fadeTimers || new Map()).forEach((timer) => clearTimeout(timer));
      if (this.cartForm && this.onReserve) this.cartForm.removeEventListener('submit', this.onReserve);
      if (this.addController) this.addController.abort();
      (this.gridNavs || []).forEach((nav) => {
        nav.grid.removeEventListener('scroll', nav.update);
        nav.prev.removeEventListener('click', nav.onPrev);
        nav.next.removeEventListener('click', nav.onNext);
      });
      this.initialized = false;
    }

    stepIndexFor(option, part) {
      return this.data.steps.findIndex((step) => step.option === option && step.part === part);
    }

    allowedKeys(step, selection) {
      const keys = new Set();
      this.variantKeys.forEach((row) => {
        for (let j = 0; j < step; j++) {
          if (row[j] !== selection[j]) return;
        }
        if (row[step] !== null && row[step] !== undefined) keys.add(row[step]);
      });
      return keys;
    }

    completeSelection(selection) {
      for (let i = 0; i < this.optionCount; i++) {
        const allowed = this.allowedKeys(i, selection);
        if (!allowed.size || allowed.has(selection[i])) continue;
        const first = this.radios[i].find((radio) => allowed.has(radio.dataset.key));
        if (first) selection[i] = first.dataset.key;
      }
      return selection;
    }

    syncAvailability() {
      this.completeSelection(this.selected);
      for (let i = 0; i < this.optionCount; i++) {
        const allowed = this.allowedKeys(i, this.selected);
        this.radios[i].forEach((radio) => {
          const ok = !allowed.size || allowed.has(radio.dataset.key);
          const wrap = radio.closest('[data-builder-option]');
          if (wrap) wrap.hidden = !ok;
          radio.disabled = !ok;
          if (radio.dataset.key === this.selected[i] && !radio.checked) radio.checked = true;
        });
      }
    }

    expectedOptions(selection) {
      const values = [];
      this.data.steps.forEach((step, i) => {
        if (step.part === -1) {
          values[step.option] = selection[i];
        } else if (step.part === 0) {
          const j = this.stepIndexFor(step.option, 1);
          values[step.option] = this.data.combos[selection[i] + '|' + selection[j]];
        }
      });
      return values;
    }

    findVariant(selection) {
      const expected = this.expectedOptions(selection);
      return this.data.variants.find((v) => v.options.every((value, i) => value === expected[i])) || null;
    }

    checkedRadio(step) {
      return (this.radios[step] || []).find((radio) => radio.checked) || null;
    }

    formatMoney(cents) {
      const format = this.data.moneyFormat || '$' + '{' + '{amount}' + '}';
      const amount = cents / 100;
      const noDecimals = /no_decimals/.test(format) || cents % 100 === 0;
      let text = noDecimals
        ? Math.round(amount).toLocaleString('en-US')
        : amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      if (/with_comma_separator/.test(format)) {
        text = text.replace(/[.,]/g, (char) => (char === ',' ? '.' : ','));
      }
      return format.replace(/\{\{\s*[a-z_]+\s*\}\}/, text);
    }

    updateDeltas() {
      for (let i = 0; i < this.optionCount; i++) {
        const variants = this.radios[i].map((radio) => {
          const selection = this.selected.slice();
          selection[i] = radio.dataset.key;
          this.completeSelection(selection);
          return this.findVariant(selection);
        });
        this.radios[i].forEach((radio, index) => {
          const el = radio.closest('[data-builder-option]');
          const img = el ? el.querySelector('[data-builder-variant-thumb] img') : null;
          if (img && variants[index]) this.setCardImage(img, variants[index].image);
        });
        const prices = variants.map((v) => (v ? v.price : null));
        const known = prices.filter((price) => price !== null);
        if (!known.length) continue;
        const min = Math.min.apply(null, known);
        this.radios[i].forEach((radio, index) => {
          const el = radio.closest('[data-builder-option]');
          const delta = el ? el.querySelector('[data-builder-delta]') : null;
          if (!delta) return;
          const diff = prices[index] === null ? 0 : prices[index] - min;
          delta.hidden = !(diff > 0);
          delta.textContent = diff > 0 ? '+' + this.formatMoney(diff) : '';
        });
      }
    }

    setCardImage(img, src) {
      if (!src) return;
      const at = (width) => src.replace(/([?&]width=)\d+/, '$1' + width);
      const next = at(600);
      if (img.getAttribute('src') === next) return;
      img.srcset = [300, 450, 600].map((width) => at(width) + ' ' + width + 'w').join(', ');
      img.src = next;
    }

    updateVariant() {
      const v = this.findVariant(this.selected);
      if (v) {
        this.variant = v;
        if (this.idInput) this.idInput.value = v.id;
        this.setText(this.priceEl, v.priceFormatted);
        this.setText(this.depositEl, v.depositFormatted);
      }
      this.available = !!v && v.available !== false;

      this.querySelectorAll('[data-builder-property]').forEach((input) => {
        const radio = this.checkedRadio(parseInt(input.dataset.builderProperty, 10));
        if (radio) input.value = radio.dataset.prop || radio.dataset.name || '';
      });
      this.querySelectorAll('[data-builder-summary-value]').forEach((el) => {
        const radio = this.checkedRadio(parseInt(el.dataset.builderSummaryValue, 10));
        if (radio) el.textContent = radio.dataset.name || '';
      });

      this.updateReserveState();
      this.updatePreview();
    }

    updateReserveState() {
      if (this.reserveBtn) {
        this.reserveBtn.disabled = this.activeIndex !== this.optionCount || !this.available;
      }
    }

    previewImage() {
      const radio = this.activeIndex < this.optionCount ? this.checkedRadio(this.activeIndex) : null;
      return (radio && radio.dataset.largeImage) || (this.variant && this.variant.image) || '';
    }

    reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    fade(el, apply, immediate) {
      if (!el) return;
      clearTimeout(this.fadeTimers.get(el));
      if (immediate || this.reducedMotion()) {
        apply();
        el.classList.remove('is-updating');
        return;
      }
      el.classList.add('is-updating');
      this.fadeTimers.set(
        el,
        setTimeout(() => {
          apply();
          el.classList.remove('is-updating');
          this.fadeTimers.delete(el);
        }, 160)
      );
    }

    setText(el, text, immediate) {
      if (!el || el.textContent.trim() === text) return;
      this.fade(el, () => { el.textContent = text; }, immediate);
    }

    swapPreviewImage(src, immediate) {
      const img = this.previewImg;
      if (!img || !src || img.getAttribute('src') === src) return;
      const load = () => {
        const done = () => img.classList.remove('is-updating');
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
        img.src = src;
        if (img.complete) done();
      };
      clearTimeout(this.fadeTimers.get(img));
      if (immediate || this.reducedMotion()) {
        load();
        return;
      }
      img.classList.add('is-updating');
      this.fadeTimers.set(img, setTimeout(load, 160));
    }

    updatePreview(immediate) {
      const radio = this.activeIndex < this.optionCount ? this.checkedRadio(this.activeIndex) : null;
      if (radio && this.info) {
        const name = radio.dataset.name || '';
        const description = radio.dataset.description || '';
        const key = name + '|' + description;
        if (key !== this.previewKey) {
          this.previewKey = key;
          this.fade(
            this.info,
            () => {
              if (this.previewName) this.previewName.textContent = name;
              if (this.previewDesc) this.previewDesc.innerHTML = description;
            },
            immediate
          );
        }
      }
      this.swapPreviewImage(this.previewImage(), immediate);
    }

    openInfo(btn) {
      const name = btn.dataset.name || '';
      const description = btn.dataset.description || '';
      const image = btn.dataset.image || '';

      if (this.infoTitle) this.infoTitle.textContent = name;
      if (this.infoDescription) this.infoDescription.innerHTML = description;

      if (this.infoMedia && this.infoImage) {
        if (image) {
          this.infoImage.src = image;
          this.infoImage.alt = name;
          this.infoMedia.hidden = false;
        } else {
          this.infoImage.removeAttribute('src');
          this.infoMedia.hidden = true;
        }
      }

      this.infoDialog.showModal();
    }

    async submitReserve(event) {
      event.preventDefault();
      if (this.adding) return;
      this.adding = true;
      if (this.reserveBtn) this.reserveBtn.setAttribute('aria-busy', 'true');
      this.addController = new AbortController();

      const url = new URL(this.cartForm.action, window.location.href);
      url.pathname = url.pathname.replace(/\/?$/, '.js');

      try {
        const response = await fetch(url.toString(), {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(this.cartForm),
          signal: this.addController.signal
        });
        if (!response.ok) throw new Error(String(response.status));
        this.dispatchEvent(new CustomEvent('cart:added', { bubbles: true }));
      } catch (error) {
        if (error.name !== 'AbortError') this.cartForm.submit();
      } finally {
        this.adding = false;
        if (this.reserveBtn) this.reserveBtn.removeAttribute('aria-busy');
      }
    }

    scrollGrid(grid, direction) {
      const card = grid.querySelector('.builder-card');
      const distance = card ? card.offsetWidth + 20 : grid.clientWidth;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      grid.scrollBy({ left: direction * distance, behavior: reduced ? 'auto' : 'smooth' });
    }

    updateGridNavs() {
      (this.gridNavs || []).forEach((nav) => nav.update());
    }

    showStep(index) {
      if (index < 0 || index > this.totalSteps - 1) return;
      const previous = this.activeIndex;
      this.activeIndex = index;
      const isReserve = index === this.optionCount;

      this.setAttribute('data-direction', index < previous ? 'back' : 'forward');
      clearTimeout(this.leaveTimer);
      this.steps.forEach((step, i) => {
        step.classList.toggle('sauna-builder__step--leaving', i === previous && i !== index);
        step.hidden = i !== index;
      });
      this.leaveTimer = setTimeout(() => {
        this.steps.forEach((step) => step.classList.remove('sauna-builder__step--leaving'));
      }, 350);

      if (this.progress) {
        this.progress.style.width = ((index + 1) / this.totalSteps) * 100 + '%';
      }
      if (this.stepCountEl && this.stepTemplate) {
        this.stepCountEl.textContent = this.stepTemplate.replace('__CURRENT__', index + 1);
      }
      if (this.prevBtn) this.prevBtn.hidden = index === 0;
      if (this.info) this.info.hidden = isReserve && window.matchMedia('(min-width: 750px)').matches;
      if (this.summary) this.summary.hidden = !isReserve;
      if (this.nextBtn) this.nextBtn.hidden = isReserve;
      if (this.reserveBtn) this.reserveBtn.hidden = !isReserve;

      this.updateReserveState();
      this.updatePreview();
      this.updateGridNavs();
    }
  }

  if (!customElements.get('sauna-builder')) {
    customElements.define('sauna-builder', SaunaBuilder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  class RelatedProducts extends HTMLElement {
    constructor() {
      super();
      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onScroll = this.onScroll.bind(this);
    }

    connectedCallback() {
      this.list = this.querySelector('[data-products]');
      this.progress = this.querySelector('scroll-progress');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      if (!this.list) return;

      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNext);
      this.list.addEventListener('scroll', this.onScroll, { passive: true });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.updateArrows());
        this.resizeObserver.observe(this.list);
      }

      this.updateArrows();
      this.load();
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrev);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNext);
      if (this.list) this.list.removeEventListener('scroll', this.onScroll);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.controller) this.controller.abort();
    }

    onPrev() {
      this.scrollByPage(-1);
    }

    onNext() {
      this.scrollByPage(1);
    }

    onScroll() {
      this.updateArrows();
    }

    async load() {
      const url = this.dataset.url;
      if (!url) return;
      this.controller = new AbortController();

      try {
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) return;
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-products]');
        if (!fresh || !fresh.children.length) return;

        this.list.innerHTML = fresh.innerHTML;
        this.list.scrollLeft = 0;
        this.list.dispatchEvent(new CustomEvent('reveal:scan', { bubbles: true }));
        if (this.progress && typeof this.progress.onResize === 'function') this.progress.onResize();
        this.updateArrows();
      } catch (error) {
        if (error.name !== 'AbortError') return;
      }
    }

    scrollByPage(direction) {
      const card = this.list.firstElementChild;
      const gap = 21;
      const step = card ? card.getBoundingClientRect().width + gap : this.list.clientWidth;
      const perPage = Math.max(1, Math.floor((this.list.clientWidth + gap) / step));
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.list.scrollBy({
        left: direction * step * perPage,
        behavior: reduced ? 'auto' : 'smooth'
      });
    }

    updateArrows() {
      const max = this.list.scrollWidth - this.list.clientWidth;
      const left = this.list.scrollLeft;
      if (this.prevButton) this.prevButton.disabled = left <= 1;
      if (this.nextButton) this.nextButton.disabled = max <= 1 || left >= max - 1;
    }
  }

  if (!customElements.get('related-products')) {
    customElements.define('related-products', RelatedProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sauna-details"] && !Shopify.designMode) return;
  try {
    
  class SaunaDetails extends HTMLElement {
    constructor() {
      super();
      this.onChange = this.onChange.bind(this);
    }

    connectedCallback() {
      this.inputs = this.querySelectorAll('[data-variant]');
      this.panels = this.querySelectorAll('[data-panel]');
      this.timers = [];
      if (!this.inputs.length || !this.panels.length) return;

      this.addEventListener('change', this.onChange);
      const checked = this.querySelector('[data-variant]:checked');
      this.show(checked ? checked.value : '1', true);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.clearTimers();
    }

    clearTimers() {
      if (!this.timers) return;
      this.timers.forEach((id) => clearTimeout(id));
      this.timers = [];
    }

    onChange(event) {
      const input = event.target.closest('[data-variant]');
      if (!input) return;
      this.show(input.value, false);
    }

    show(variant, immediate) {
      this.clearTimers();

      const motionOk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const fade = !immediate && motionOk;

      this.panels.forEach((panel) => {
        const active = panel.getAttribute('data-panel') === variant;

        if (active) {
          panel.removeAttribute('data-inert');
          panel.hidden = false;
          return;
        }

        panel.hidden = true;

        if (fade) {
          this.timers.push(
            setTimeout(() => {
              if (panel.hidden) panel.setAttribute('data-inert', '');
            }, 300)
          );
        } else {
          panel.setAttribute('data-inert', '');
        }
      });
    }
  }

  if (!customElements.get('sauna-details')) {
    customElements.define('sauna-details', SaunaDetails);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sauna-showcase"] && !Shopify.designMode) return;
  try {
    
  class SaunaShowcase extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.activeIndex = 0;
      this.pauseHover = false;
      this.pauseFocus = false;
      this.pauseEditor = false;
      this.inView = true;
      [
        'onPointerOver',
        'onPointerLeave',
        'onClick',
        'onFocusIn',
        'onFocusOut',
        'onVisibility',
        'onMotionChange',
        'onBlockSelect',
        'onBlockDeselect',
        'next',
      ].forEach((fn) => {
        this[fn] = this[fn].bind(this);
      });
    }

    connectedCallback() {
      this.list = this.querySelector('[data-sauna-list]');
      const names = Array.from(this.querySelectorAll('[data-sauna-name]'));
      this.count = names.length;

      this.items = names.map((name) => {
        const i = name.dataset.saunaIndex;
        return {
          index: Number(i),
          name: name,
          cyclable: name.hasAttribute('data-sauna-cyclable'),
          media: this.querySelector('[data-sauna-media] [data-sauna-index="' + i + '"]'),
          description: this.querySelector('[data-sauna-descriptions] [data-sauna-index="' + i + '"]'),
        };
      });
      this.cyclable = this.items.filter((item) => item.cyclable).map((item) => item.index);

      const active = this.querySelector('[data-sauna-name].is-active');
      this.activeIndex = active ? Number(active.dataset.saunaIndex) : 0;
      this.interval = (Number(this.dataset.autoplayInterval) || 5) * 1000;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (this.count > 1 && this.list) {
        this.list.addEventListener('pointerover', this.onPointerOver);
        this.list.addEventListener('pointerleave', this.onPointerLeave);
        this.list.addEventListener('click', this.onClick);
        this.list.addEventListener('focusin', this.onFocusIn);
        this.list.addEventListener('focusout', this.onFocusOut);
      }

      if (this.cyclable.length > 1) {
        document.addEventListener('visibilitychange', this.onVisibility);
        this.motionQuery.addEventListener('change', this.onMotionChange);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              this.inView = entries[0].isIntersecting;
              this.sync();
            },
            { threshold: 0.2 }
          );
          this.observer.observe(this);
        }
      }

      this.addEventListener('shopify:block:select', this.onBlockSelect);
      this.addEventListener('shopify:block:deselect', this.onBlockDeselect);

      this.setActive(this.activeIndex);
      this.sync();
    }

    disconnectedCallback() {
      this.stop();
      if (this.list) {
        this.list.removeEventListener('pointerover', this.onPointerOver);
        this.list.removeEventListener('pointerleave', this.onPointerLeave);
        this.list.removeEventListener('click', this.onClick);
        this.list.removeEventListener('focusin', this.onFocusIn);
        this.list.removeEventListener('focusout', this.onFocusOut);
      }
      document.removeEventListener('visibilitychange', this.onVisibility);
      if (this.motionQuery) {
        this.motionQuery.removeEventListener('change', this.onMotionChange);
      }
      if (this.observer) {
        this.observer.disconnect();
      }
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    setActive(index) {
      if (index == null || index < 0 || index >= this.count) return;
      this.activeIndex = index;
      const reduced = this.motionQuery && this.motionQuery.matches;

      this.items.forEach((item) => {
        const on = item.index === index;
        item.name.classList.toggle('is-active', on);
        if (item.media) item.media.classList.toggle('is-active', on);
        if (item.description) item.description.classList.toggle('is-active', on);

        if (item.media && !reduced) {
          const video = item.media.querySelector('video');
          if (video) {
            if (on) {
              const played = video.play();
              if (played && played.catch) played.catch(() => {});
            } else {
              video.pause();
            }
          }
        }
      });
    }

    next() {
      if (this.cyclable.length === 0) return;
      let target = this.cyclable[0];
      for (let k = 0; k < this.cyclable.length; k++) {
        if (this.cyclable[k] > this.activeIndex) {
          target = this.cyclable[k];
          break;
        }
      }
      this.setActive(target);
    }

    canRun() {
      const reduced = this.motionQuery && this.motionQuery.matches;
      return (
        this.cyclable.length > 1 &&
        this.inView &&
        !document.hidden &&
        !this.pauseHover &&
        !this.pauseFocus &&
        !this.pauseEditor &&
        !reduced
      );
    }

    sync() {
      if (this.canRun()) {
        this.start();
      } else {
        this.stop();
      }
    }

    start() {
      if (!this.timer) {
        this.timer = window.setInterval(this.next, this.interval);
      }
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    restart() {
      this.stop();
      this.sync();
    }

    indexFromEvent(event) {
      const name = event.target.closest ? event.target.closest('[data-sauna-name]') : null;
      return name ? Number(name.dataset.saunaIndex) : null;
    }

    onPointerOver(event) {
      if (event.pointerType === 'touch') return;
      this.pauseHover = true;
      const i = this.indexFromEvent(event);
      if (i != null) this.setActive(i);
      this.sync();
    }

    onPointerLeave(event) {
      if (event.pointerType === 'touch') return;
      this.pauseHover = false;
      this.sync();
    }

    onClick(event) {
      const i = this.indexFromEvent(event);
      if (i == null || i === this.activeIndex) return;
      event.preventDefault();
      this.setActive(i);
      this.restart();
    }

    onFocusIn(event) {
      if (!event.target.matches(':focus-visible')) return;
      this.pauseFocus = true;
      const i = this.indexFromEvent(event);
      if (i != null) this.setActive(i);
      this.sync();
    }

    onFocusOut(event) {
      if (this.list.contains(event.relatedTarget)) return;
      this.pauseFocus = false;
      this.sync();
    }

    onVisibility() {
      this.sync();
    }

    onMotionChange() {
      this.sync();
    }

    onBlockSelect(event) {
      this.pauseEditor = true;
      const i = this.indexFromEvent(event);
      if (i != null) this.setActive(i);
      this.sync();
    }

    onBlockDeselect() {
      this.pauseEditor = false;
      this.sync();
    }
  }

  if (!customElements.get('sauna-showcase')) {
    customElements.define('sauna-showcase', SaunaShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-product"] && !Shopify.designMode) return;
  try {
    
  class ShopProduct extends HTMLElement {
    constructor() {
      super();
      this.loading = false;
      this.onVariantChange = this.onVariantChange.bind(this);
      this.onQuantityChange = this.onQuantityChange.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('form[data-product-form]');
      this.select = this.querySelector('[data-variant-select]');
      this.quantity = this.querySelector('[data-quantity-input]');
      this.minus = this.querySelector('[data-step="-1"]');
      this.priceText = this.querySelector('[data-price-text]');
      this.compare = this.querySelector('[data-compare]');
      this.compareText = this.querySelector('[data-compare-text]');
      this.saleLabel = this.querySelector('[data-sale-label]');
      this.submit = this.querySelector('[data-submit]');
      this.submitText = this.submit ? this.submit.querySelector('.button__text') : null;
      this.status = this.querySelector('[data-status]');

      if (this.select) this.select.addEventListener('change', this.onVariantChange);
      if (this.quantity) {
        this.quantity.addEventListener('change', this.onQuantityChange);
        this.setQuantity(this.readQuantity());
      }
      this.addEventListener('click', this.onClick);
      if (this.form) this.form.addEventListener('submit', this.onSubmit);
    }

    disconnectedCallback() {
      if (this.select) this.select.removeEventListener('change', this.onVariantChange);
      if (this.quantity) this.quantity.removeEventListener('change', this.onQuantityChange);
      this.removeEventListener('click', this.onClick);
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);
      if (this.controller) this.controller.abort();
      clearTimeout(this.addedTimer);
    }

    readQuantity() {
      const value = parseInt(this.quantity.value, 10);
      return isNaN(value) || value < 1 ? 1 : value;
    }

    setQuantity(value) {
      const quantity = Math.max(1, value);
      this.quantity.value = String(quantity).padStart(2, '0');
      if (!this.minus) return;
      if (quantity <= 1) {
        this.minus.setAttribute('aria-disabled', 'true');
      } else {
        this.minus.removeAttribute('aria-disabled');
      }
    }

    onQuantityChange() {
      this.setQuantity(this.readQuantity());
    }

    onClick(event) {
      const step = event.target.closest('[data-step]');
      if (!step || !this.quantity) return;
      if (step.getAttribute('aria-disabled') === 'true') return;
      this.setQuantity(this.readQuantity() + parseInt(step.dataset.step, 10));
    }

    onVariantChange() {
      const option = this.select.options[this.select.selectedIndex];
      if (!option) return;

      if (this.priceText) this.priceText.textContent = option.dataset.price;

      const compare = option.dataset.comparePrice || '';
      if (this.compare) {
        this.compare.hidden = compare === '';
        if (this.compareText) this.compareText.textContent = compare;
      }
      if (this.saleLabel) this.saleLabel.hidden = compare === '';

      const available = option.dataset.available === 'true';
      if (this.submit) {
        this.submit.disabled = !available;
        if (this.submitText) {
          this.submitText.textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
        }
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url.toString());
    }

    async onSubmit(event) {
      event.preventDefault();
      if (this.loading) return;
      this.loading = true;
      if (this.submit) this.submit.setAttribute('aria-busy', 'true');
      this.controller = new AbortController();

      const url = new URL(this.form.action, window.location.href);
      url.pathname = url.pathname.replace(/\/?$/, '.js');

      try {
        const response = await fetch(url.toString(), {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(this.form),
          signal: this.controller.signal
        });
        if (!response.ok) throw new Error(String(response.status));

        await this.updateCartCount();
        this.announce(this.dataset.addedLabel);
        this.dispatchEvent(new CustomEvent('cart:added', { bubbles: true }));
        this.flashAdded();
      } catch (error) {
        if (error.name !== 'AbortError') this.form.submit();
      } finally {
        this.loading = false;
        if (this.submit) this.submit.removeAttribute('aria-busy');
      }
    }

    flashAdded() {
      if (!this.submitText) return;
      clearTimeout(this.addedTimer);
      this.submitText.textContent = this.dataset.addedText;
      this.addedTimer = setTimeout(() => {
        this.submitText.textContent = this.dataset.addLabel;
      }, 2000);
    }

    async updateCartCount() {
      const response = await fetch(this.dataset.cartUrl, {
        headers: { Accept: 'application/json' },
        signal: this.controller.signal
      });
      if (!response.ok) return;

      const cart = await response.json();
      const count = String(cart.item_count);
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
      });

      const label = this.dataset.cartLabel;
      if (!label) return;
      document.querySelectorAll('[data-cart-count-label]').forEach((el) => {
        el.textContent = label.replace('__count__', count);
      });
    }

    announce(text) {
      if (!this.status || !text) return;
      this.status.textContent = '';
      window.requestAnimationFrame(() => {
        this.status.textContent = text;
      });
    }
  }

  if (!customElements.get('shop-product')) {
    customElements.define('shop-product', ShopProduct);
  }

  class ShopReviews extends HTMLElement {
    constructor() {
      super();
      this.loaded = false;
      this.onToggle = this.onToggle.bind(this);
      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.details = this.closest('details');
      this.endpoint = this.dataset.endpoint;
      this.productId = this.dataset.productId;
      this.perPage = parseInt(this.dataset.perPage, 10) || 20;
      this.labels = {
        loading: this.dataset.labelLoading || '',
        empty: this.dataset.labelEmpty || '',
        error: this.dataset.labelError || '',
        rating: this.dataset.labelRating || '',
        more: this.dataset.labelMore || '',
        less: this.dataset.labelLess || ''
      };
      this.status = this.querySelector('[data-reviews-status]');
      this.scroller = this.querySelector('[data-scroller]');
      this.template = this.querySelector('[data-review-template]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');

      if (!this.scroller || !this.template) return;

      if (this.details) this.details.addEventListener('toggle', this.onToggle);
      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNext);
      this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
      this.addEventListener('click', this.onClick);

      this.markOverflow();
      this.syncRowHeight();
      this.updateArrows();

      if (this.endpoint && (!this.details || this.details.open)) this.load();
    }

    disconnectedCallback() {
      if (this.details) this.details.removeEventListener('toggle', this.onToggle);
      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrev);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNext);
      if (this.scroller) this.scroller.removeEventListener('scroll', this.onScroll);
      this.removeEventListener('click', this.onClick);
      if (this.controller) this.controller.abort();
    }

    onToggle() {
      if (this.endpoint && this.details.open && !this.loaded) this.load();
    }

    onPrev() {
      this.scrollByPage(-1);
    }

    onNext() {
      this.scrollByPage(1);
    }

    onScroll() {
      this.updateArrows();
    }

    onClick(event) {
      const button = event.target.closest('[data-more]');
      if (!button) return;
      const card = button.closest('.shop-product__review');
      if (!card) return;
      const expanded = card.classList.toggle('is-expanded');
      button.textContent = expanded ? this.labels.less : this.labels.more;
      if (!expanded) this.syncRowHeight();
    }

    load() {
      this.loaded = true;
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.setStatus(this.labels.loading);

      fetch(this.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          domain_key: this.productId,
          page: 1,
          per_page: this.perPage,
          sortings: [{ sort_by: 'date', ascending: false }]
        }),
        signal: this.controller.signal
      })
        .then((response) => {
          if (!response.ok) throw new Error(String(response.status));
          return response.json();
        })
        .then((data) => {
          const reviews = data && data.response && Array.isArray(data.response.reviews) ? data.response.reviews : [];
          if (!reviews.length) {
            this.setStatus('');
            return;
          }
          this.render(reviews);
          this.setStatus('');
        })
        .catch((error) => {
          if (error && error.name === 'AbortError') return;
          this.loaded = false;
          this.setStatus(this.labels.error);
        });
    }

    setStatus(text) {
      if (!this.status) return;
      this.status.textContent = text;
      this.status.hidden = !text;
    }

    render(reviews) {
      this.scroller.textContent = '';
      const fragment = document.createDocumentFragment();
      reviews.forEach((review) => fragment.appendChild(this.buildCard(review)));
      this.scroller.appendChild(fragment);
      this.scroller.scrollLeft = 0;
      this.markOverflow();
      this.syncRowHeight();
      this.updateArrows();
    }

    buildCard(review) {
      const card = this.template.content.firstElementChild.cloneNode(true);
      const name = review.user && review.user.display_name ? review.user.display_name : '';
      const score = Math.round(Number(review.score) || 0);

      card.querySelector('[data-text]').textContent = (review.content || '').replace(/\bVim\b/g, 'VIM').trim();
      card.querySelector('[data-more]').textContent = this.labels.more;
      card.querySelectorAll('[data-stars] .shop-product__review-star').forEach((star, index) => {
        star.classList.toggle('shop-product__review-star--empty', index >= score);
      });
      card.querySelector('[data-rating]').textContent = this.labels.rating.replace('__SCORE__', String(score));
      card.querySelector('[data-name]').textContent = name;

      return card;
    }

    markOverflow() {
      this.scroller.querySelectorAll('.shop-product__review').forEach((card) => {
        const text = card.querySelector('[data-text]');
        const more = card.querySelector('[data-more]');
        if (!text || !more) return;
        more.hidden = text.scrollHeight <= text.clientHeight + 1;
      });
    }

    syncRowHeight() {
      this.scroller.style.removeProperty('--row-height');
      let max = 0;
      this.scroller.querySelectorAll('.shop-product__review:not(.is-expanded)').forEach((card) => {
        max = Math.max(max, card.offsetHeight);
      });
      if (max) this.scroller.style.setProperty('--row-height', max + 'px');
    }

    scrollByPage(direction) {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.scroller.scrollBy({
        left: direction * this.scroller.clientWidth,
        behavior: reduced ? 'auto' : 'smooth'
      });
    }

    updateArrows() {
      const max = this.scroller.scrollWidth - this.scroller.clientWidth;
      const left = this.scroller.scrollLeft;
      if (this.prevButton) this.prevButton.disabled = left <= 1;
      if (this.nextButton) this.nextButton.disabled = max <= 1 || left >= max - 1;
    }
  }

  if (!customElements.get('shop-reviews')) {
    customElements.define('shop-reviews', ShopReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-player"] && !Shopify.designMode) return;
  try {
    
  class VideoPlayer extends HTMLElement {
    constructor() {
      super();
      this.onButtonClick = this.onButtonClick.bind(this);
      this.onPlay = this.onPlay.bind(this);
    }

    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('.video-player__play');
      if (!this.video) return;

      if (this.video.autoplay) {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.video.removeAttribute('autoplay');
          this.video.pause();
          this.video.controls = true;
        }
        return;
      }

      if (!this.button) return;
      this.video.controls = false;
      this.button.hidden = false;
      this.button.addEventListener('click', this.onButtonClick);
      this.video.addEventListener('play', this.onPlay);
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.onButtonClick);
      if (this.video) this.video.removeEventListener('play', this.onPlay);
    }

    onButtonClick() {
      this.video.controls = true;
      const played = this.video.play();
      if (played && played.catch) played.catch(function () {});
    }

    onPlay() {
      this.video.controls = true;
      this.classList.add('is-playing');
    }
  }

  if (!customElements.get('video-player')) {
    customElements.define('video-player', VideoPlayer);
  }

  } catch(e) { console.error(e); }
})();
})();
